/**
 * Single source for the API origin, mirroring ev-portal-app/src/apiConfig.ts.
 *
 * Defaults to the local API so the project runs with no .env at all.
 */
export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/";

export const WS_URL = API_URL.replace(/^http/, "ws");
